/** Validate NPI check digit using the Luhn algorithm with prefix 80840. */
export function isValidNpiCheckDigit(npi: string): boolean {
  const digits = ('80840' + npi).split('').map(Number);
  let total = 0;
  for (let i = digits.length - 1; i >= 0; i--) {
    const pos = digits.length - 1 - i;
    let d = digits[i];
    if (pos % 2 === 1) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    total += d;
  }
  return total % 10 === 0;
}

/** Return only numeric characters from user-entered NPI text. */
export function sanitizeNpiInput(npi: string): string {
  return npi.replace(/\D/g, '');
}

/** Validate an NPI string, returning an error message or null if valid. */
export function validateNpi(npi: string): string | null {
  const trimmedNpi = npi.trim();

  if (trimmedNpi === '') {
    return null;
  }

  if (!/^\d*$/.test(trimmedNpi)) {
    return 'NPI must contain only digits';
  }
  if (trimmedNpi.length !== 10) {
    return 'NPI must be exactly 10 digits';
  }
  if (!isValidNpiCheckDigit(trimmedNpi)) {
    return 'Invalid NPI check digit';
  }
  return null;
}
